import React, { useState, useEffect, useContext, useRef } from 'react';
import './LatestCheckIn.css';
import { format, parseISO } from 'date-fns';
import { CardLatestCheckInContext } from '../../contexts/CardLatestCheckInContext';
import logComponent from '../../common/logComponent';

export default function LatestCheckInContent() {
  const cardLatestCheckInContext = useContext(CardLatestCheckInContext);
  const [contentData, setContentData] = useState(null);
  const [noteOverlayVisible, setNoteOverlayVisible] = useState(false);
  const [needCheckOverlayVisibility, setNeedCheckOverlayVisibility] = useState(false);
  const noteRef = useRef(null);

  if (logComponent('LatestCheckInContent')) { console.debug('LatestCheckInContent rendered'); }

  useEffect(() => {
    if (logComponent('LatestCheckInContent')) {console.debug('LatestCheckInContent useEffect [cardLatestCheckInContext.latestCheckIn]'); }
    setContentData(cardLatestCheckInContext.latestCheckIn ? { ...cardLatestCheckInContext.latestCheckIn } : null);
    setNeedCheckOverlayVisibility(true);
  }, [cardLatestCheckInContext.latestCheckIn]);


  useEffect(() => {
    if (logComponent('LatestCheckInContent')) {console.debug('LatestCheckInContent useEffect  [needCheckOverlayVisibility]'); }

    if (needCheckOverlayVisibility === true) {
      checkOverlayVisibility();
      setNeedCheckOverlayVisibility(false);
    }
  }, [needCheckOverlayVisibility]);



  const getSelectedDateFormatted = (date) => {
    if (logComponent('LatestCheckInContent')) {console.debug('LatestCheckInContent getSelectedDateFormatted'); }
    return date ? format(parseISO(date), 'MMMM d, yyyy') : null;

  }

  const setNoteRef = (el) => {
    if (logComponent('LatestCheckInContent')) {console.debug('LatestCheckInContent setNoteRef'); }
    noteRef.current = el;
  }  



  const checkOverlayVisibility = () => {
    if (logComponent('LatestCheckInContent')) {console.debug('LatestCheckInContent checkOverlayVisibility'); }
    if (!noteRef.current) return;
    
    if (noteRef.current.scrollHeight > noteRef.current.clientHeight + noteRef.current.scrollTop) {
      setNoteOverlayVisible(true)
    } else {
      setNoteOverlayVisible(false)
    }
  }


return (contentData &&
  (
    contentData.staffCheckHistoryId !== 0 ?
      <React.Fragment>
        <dl className="Latest-Checkin__info-list">
          <dt>Staff member:</dt>
          <dd>{contentData.user.legalFirstName} {contentData.user.lastName}</dd>
          <dt>Date:</dt>
          <dd>{getSelectedDateFormatted(contentData.localCheckInOn)}</dd>
        </dl>
        <div className="Latest-Checkin__note">
          <div className={'Latest-Checkin__note-overlay' + (noteOverlayVisible ? ' Latest-Checkin__note-overlay--visible' : '')}></div>
          <p className="Latest-Checkin__note-heading">Check in note:</p>
          <p className="Latest-Checkin__note-text" ref={setNoteRef} onScroll={checkOverlayVisibility}>{contentData.familyNote ? contentData.familyNote.body : null}</p>
        </div>
      </React.Fragment> :
      <p className="Latest-Checkin__empty-message">No check-in found</p>));
}

